import ReactConfetti from "react-confetti"

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height,
  }
}

interface Props {
  onFinish: () => void
}

export default function Confetti({ onFinish }: Props) {
  const { width, height } = getWindowDimensions()

  return (
    <ReactConfetti
      colors={[
        "#D6CFFE",
        "#FDD5D5",
        "#C5F596",
        "#DAEBFF",
        "#FEDAAE",
        "#FFF5A2",
      ]}
      height={height}
      numberOfPieces={300}
      onConfettiComplete={onFinish}
      recycle={false}
      tweenDuration={10}
      width={width}
    />
  )
}
